import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-library-categories',
    templateUrl: './library-categories.component.html',
    styleUrls: ['./library-categories.component.scss'],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatChipsModule,
        MatIconModule,
    ]
})
export class LibraryCategoriesComponent implements OnInit {
  private firestore: firebase.firestore.Firestore;
  tags: string[] = [];

  constructor() {
    if (!firebase.apps.length) {
      firebase.initializeApp(environment.config);
    }
    this.firestore = firebase.firestore();
  }

  ngOnInit(): void {
    this.loadTags();
  }

  loadTags(): void {
    const libraryCategoriesRef = this.firestore.collection('libraryTags');
    libraryCategoriesRef
      .get()
      .then(querySnapshot => {
        this.tags = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (data.tag) {
            this.tags.push(data.tag);
          }
        });
      })
      .catch(error => {
        console.error('Error loading tags: ', error);
      });
  }

  addTag(tag: string): void {
    if (tag && !this.tags.includes(tag)) {
      this.tags.push(tag);
    }
  }

  saveTags(): void {
    const libraryCategoriesRef = this.firestore.collection('libraryTags');
    const batch = this.firestore.batch();

    this.tags.forEach(tag => {
      const docRef = libraryCategoriesRef.doc(tag); // Use tag as document ID to avoid duplication
      batch.set(docRef, { tag }, { merge: true });
    });

    batch
      .commit()
      .then(() => {
        console.log('Tags saved successfully!');
      })
      .catch(error => {
        console.error('Error saving tags: ', error);
      });
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }
}
